import SidebarComponent from "../../components/Sidebar/SidebarComponent";
import { Avatar } from "primereact/avatar";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import { FormAccessLogin } from "../Login/models/login.model";
import { useForm } from "react-hook-form";
import {
  getDataUserByIdService,
  saveDataUserService,
  changePasswordUser,
} from "./services/profile.service";
import { EditProfile} from "./models/Profile.model";
import { ProfileUserData } from "../HomeAdmin/components/AdminUsers/models/adminUsers.model";
import ToastBackControl from "../../components/Sidebar/ToastBackControl/ToastBackControl";
import { ToastControlBackendModel } from "../../components/Sidebar/ToastBackControl/models/toastBackControl.model";
import { ChangePasswordUser } from "./models/change-passwordUser.model";
 
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');
 
  .pf-root *, .pf-root *::before, .pf-root *::after {
    box-sizing: border-box;
  }
 
  .pf-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #f4f6f9;
    min-height: 100vh;
    color: #1a1d23;
  }
 
  /* ── Top bar ── */
  .pf-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    height: 64px;
    background: #ffffff;
    border-bottom: 1px solid #e8eaed;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .pf-topbar-brand {
    font-size: 1.1rem;
    font-weight: 800;
    color: #1a1d23;
    letter-spacing: -0.5px;
  }
  .pf-topbar-brand span { color: #00A86B; }
 
  /* ── Page layout ── */
  .pf-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 48px 24px 80px;
  }
 
  /* ── Card ── */
  .pf-card {
    background: #fff;
    border-radius: 24px;
    border: 1px solid #e8eaed;
    box-shadow: 0 4px 32px rgba(0,0,0,0.06);
    width: 100%;
    max-width: 520px;
    overflow: hidden;
  }
 
  /* Card header banner */
  .pf-card-banner {
    background: linear-gradient(135deg, #00A86B 0%, #007a4d 100%);
    height: 90px;
    position: relative;
  }
 
  /* Avatar area */
  .pf-avatar-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -44px;
    padding: 0 32px 8px;
    position: relative;
  }
  .pf-avatar-ring {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(0,168,107,0.2);
    border: 3px solid #fff;
  }
  .pf-avatar-ring .p-avatar {
    width: 76px !important;
    height: 76px !important;
    background: linear-gradient(135deg, #00A86B, #007a4d) !important;
    border-radius: 50% !important;
  }
  .pf-avatar-ring .p-avatar .p-avatar-icon {
    font-size: 2rem !important;
    color: #fff !important;
  }
  .pf-user-id {
    margin-top: 10px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #e6faf2;
    border: 1px solid #b3ecd7;
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 0.72rem;
    font-weight: 700;
    color: #00875a;
  }
 
  /* Card content */
  .pf-card-content {
    padding: 24px 32px 32px;
  }
  .pf-section-title {
    font-size: 1.15rem;
    font-weight: 800;
    color: #1a1d23;
    letter-spacing: -0.3px;
    margin: 0 0 4px;
  }
  .pf-section-sub {
    font-size: 0.78rem;
    color: #9ca3af;
    margin: 0 0 28px;
  }
 
  /* Fields */
  .pf-fields {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  .pf-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .pf-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #6b7280;
  }
  .pf-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .pf-input-icon {
    position: absolute;
    left: 14px;
    color: #9ca3af;
    font-size: 0.9rem;
    pointer-events: none;
    z-index: 1;
  }
  .pf-input-wrap .p-inputtext {
    width: 100% !important;
    padding: 11px 14px 11px 38px !important;
    border-radius: 12px !important;
    border: 1.5px solid #e8eaed !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.88rem !important;
    color: #1a1d23 !important;
    background: #f9fafb !important;
    transition: border-color 0.15s, box-shadow 0.15s !important;
    box-shadow: none !important;
  }
  .pf-input-wrap .p-inputtext:not(:disabled):focus {
    border-color: #00A86B !important;
    background: #fff !important;
    box-shadow: 0 0 0 3px rgba(0,168,107,0.12) !important;
    outline: none !important;
  }
  .pf-input-wrap .p-inputtext:disabled {
    background: #f4f6f9 !important;
    color: #717174ff !important;
    cursor: not-allowed !important;
  }
  /* Active/editable field highlight */
  .pf-input-wrap.active .p-inputtext:not(:disabled) {
    border-color: #00A86B !important;
    background: #fff !important;
  }
 
  /* Divider */
  .pf-divider {
    height: 1px;
    background: #e8eaed;
    margin: 28px 0;
  }
 
  /* Actions */
  .pf-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
  .pf-btn-edit.p-button {
    background: #00A86B !important;
    border: none !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.85rem !important;
    padding: 11px 28px !important;
    box-shadow: 0 4px 14px rgba(0,168,107,0.28) !important;
    transition: box-shadow 0.2s, transform 0.15s !important;
  }
  .pf-btn-edit.p-button:hover {
    background: #009960 !important;
    box-shadow: 0 6px 20px rgba(0,168,107,0.38) !important;
    transform: translateY(-1px) !important;
  }
  .pf-btn-cancel.p-button {
    background: transparent !important;
    border: 1.5px solid #e8eaed !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.85rem !important;
    padding: 11px 24px !important;
    color: #6b7280 !important;
    box-shadow: none !important;
    transition: border-color 0.15s, color 0.15s !important;
  }
  .pf-btn-cancel.p-button:hover {
    border-color: #00A86B !important;
    color: #00A86B !important;
    background: #f0fdf8 !important;
  }

  /* ── Change password dialog ── */
  .pf-dialog, .pf-dialog * { box-sizing: border-box; }
  .pf-dialog.p-dialog {
    border-radius: 24px !important;
    overflow: hidden;
    border: 1px solid #e8eaed;
    box-shadow: 0 4px 32px rgba(0,0,0,0.12) !important;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .pf-dialog .p-dialog-header {
    padding: 24px 32px 0 !important;
    background: #fff !important;
  }
  .pf-dialog .p-dialog-title {
    font-size: 1.15rem !important;
    font-weight: 800 !important;
    color: #1a1d23;
    letter-spacing: -0.3px;
  }
  .pf-dialog .p-dialog-content {
    padding: 8px 32px 8px !important;
    background: #fff !important;
  }
  .pf-dialog .p-dialog-footer {
    padding: 16px 32px 28px !important;
    background: #fff !important;
    border: none !important;
  }
  .pf-security-note {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    background: #e6faf2;
    border: 1px solid #b3ecd7;
    border-radius: 12px;
    padding: 10px 14px;
    font-size: 0.78rem;
    color: #00875a;
    margin: 0 0 20px;
  }
  .pf-error-text {
    font-size: 0.72rem;
    font-weight: 600;
    color: #dc2626;
  }
  .pf-btn-edit.p-button:disabled {
    opacity: 0.5;
    transform: none !important;
    box-shadow: none !important;
  }
 
  @media (max-width: 600px) {
    .pf-body { padding: 24px 16px 100px; }
    .pf-card-content { padding: 20px 20px 24px; }
    .pf-topbar { padding: 0 18px; }
  }
`;

const emptyPasswordForm = {
  citizenshipId: "",
  city: "",
  address: "",
  newPassword: "",
  confirmPassword: "",
};
 
function Profile(): JSX.Element {
  const idUser = localStorage.getItem("idUser");
  const [editShape, setEditShape] = useState<boolean>(true);
  const { handleSubmit } = useForm<FormAccessLogin>({ mode: "onChange" });
  const [dataProfile, setDataProfile] = useState<ProfileUserData>();
  const [name, setName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [phone, setPhone] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [messageBackend, setMessageBackend] = useState<ToastControlBackendModel>({
    severityValue: "info",
    detailValue: "",
    lifeValue: 3000,
    validateShowMessage: false,
  });

  // ── Change password ──
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [passwordLoading, setPasswordLoading] = useState<boolean>(false);
  const [passwordForm, setPasswordForm] = useState(emptyPasswordForm);

  const handlePasswordField = (field: keyof typeof passwordForm, value: string): void =>
    setPasswordForm((prev) => ({ ...prev, [field]: value }));

  const passwordsMatch = passwordForm.newPassword === passwordForm.confirmPassword;

  const isPasswordFormValid =
    passwordForm.citizenshipId.trim() !== "" &&
    passwordForm.city.trim() !== "" &&
    passwordForm.address.trim() !== "" &&
    passwordForm.newPassword !== "" &&
    passwordsMatch;

  const closePasswordModal = (): void => {
    setShowPasswordModal(false);
    setPasswordForm(emptyPasswordForm);
  };

  const onChangePassword = async (): Promise<void> => {
    if (!isPasswordFormValid) return;
    setPasswordLoading(true);
    try {
      const payload: ChangePasswordUser = {
        idUser: Number(idUser),
        password: passwordForm.newPassword,
        citizenshipId: passwordForm.citizenshipId.trim(),
        city: passwordForm.city.trim(),
        address: passwordForm.address.trim(),
      };
      const response = await changePasswordUser(payload);

      if (response.statusCode < 299) {
        closePasswordModal();
        setMessageBackend({ severityValue: "success", detailValue: "Contraseña actualizada correctamente", lifeValue: 3000, validateShowMessage: true });
      } else {
        setMessageBackend({ severityValue: "error", detailValue: "No se pudo verificar la información", lifeValue: 3000, validateShowMessage: true });
      }
    } catch (error) {
      setMessageBackend({ severityValue: "error", detailValue: "Error al cambiar la contraseña", lifeValue: 3000, validateShowMessage: true });
    } finally {
      setPasswordLoading(false);
    }
  };
 
  const getDataProfile = async (): Promise<void> => {
    try {
      if (idUser) {
        const response = await getDataUserByIdService(+idUser);
        if (response.data) setDataProfile(response.data);
      }
    } catch (error) {}
  };
 
  useEffect(() => {
    getDataProfile();
    window.removeEventListener("beforeunload", localStorage.clear);
  }, []);
 
  const onSubmit = async (): Promise<void> => {
    setLoading(true);
    try {
      const dataUpdateProfile: EditProfile = {
        idUser: Number(idUser),
        name: name ? String(name) : String(dataProfile?.name),
        lastName: lastName ? String(lastName) : String(dataProfile?.lastName),
        phone: phone ? String(phone) : String(dataProfile?.phone),
      };
      const response = await saveDataUserService(dataUpdateProfile);
      if (response.statusCode < 299) {
        getDataProfile();
        setEditShape(true);
        setMessageBackend({ severityValue: "success", detailValue: "Perfil actualizado correctamente", lifeValue: 3000, validateShowMessage: true });
      }
    } catch (error) {
      setMessageBackend({ severityValue: "error", detailValue: "Error al actualizar el perfil", lifeValue: 3000, validateShowMessage: true });
    } finally {
      setLoading(false);
    }
  };
 
  const initials = dataProfile
    ? `${dataProfile.name?.[0] ?? ""}${dataProfile.lastName?.[0] ?? ""}`.toUpperCase()
    : "";
 
  return (
    <>
      <style>{styles}</style>
      <div className="pf-root">
        <SidebarComponent />
 
        {messageBackend.validateShowMessage && (
          <ToastBackControl
            validateShowMessage={messageBackend.validateShowMessage}
            detailValue={messageBackend.detailValue}
            lifeValue={messageBackend.lifeValue}
            severityValue={messageBackend.severityValue}
          />
        )}
 
        {/* Top bar */}
        <header className="pf-topbar">
          <div className="pf-topbar-brand">
            BI<span>Capital</span>
          </div>
        </header>
 
        <div className="pf-body">
          <div className="pf-card">
 
            {/* Green banner */}
            <div className="pf-card-banner" />
 
            {/* Avatar */}
            <div className="pf-avatar-wrap">
              <div className="pf-avatar-ring">
                <Avatar icon="pi pi-user" size="xlarge" shape="circle" />
              </div>
              {dataProfile && (
                <div className="pf-user-id">
                  <i className="pi pi-id-card" style={{ fontSize: "0.7rem" }} />
                  ID: {dataProfile.idUser}
                </div>
              )}
            </div>
 
            {/* Content */}
            <div className="pf-card-content">
              <p className="pf-section-title">Información personal</p>
              <p className="pf-section-sub">Administra los datos de tu cuenta</p>
 
              {dataProfile && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="pf-fields">
 
                    <div className="pf-field">
                      <label className="pf-label">Nombre</label>
                      <div className={`pf-input-wrap${!editShape ? " active" : ""}`}>
                        <i className="pf-input-icon pi pi-user" />
                        <InputText
                          disabled={editShape}
                          value={name ?? dataProfile.name} 
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
 
                    <div className="pf-field">
                      <label className="pf-label">Apellido</label>
                      <div className={`pf-input-wrap${!editShape ? " active" : ""}`}>
                        <i className="pf-input-icon pi pi-user" />
                        <InputText
                          disabled={editShape}
                          value={lastName ?? dataProfile.lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </div>
                    </div>
 
                    <div className="pf-field">
                      <label className="pf-label">Usuario</label>
                      <div className="pf-input-wrap">
                        <i className="pf-input-icon pi pi-at" />
                        <InputText
                          disabled
                          value={dataProfile.user}
                        />
                      </div>
                    </div>
 
                    <div className="pf-field">
                      <label className="pf-label">Teléfono</label>
                      <div className={`pf-input-wrap${!editShape ? " active" : ""}`}>
                        <i className="pf-input-icon pi pi-phone" />
                        <InputText
                          disabled={editShape}
                          value={phone ?? dataProfile.phone} 
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
 
                  </div>
 
                  <div className="pf-divider" />
 
                  <div className="pf-actions">
                    {!editShape ? (
                      <>
                        <Button
                          type="button"
                          label="Cancelar"
                          className="pf-btn-cancel"
                          onClick={() => setEditShape(true)}
                        />
                        <Button
                          type="button"
                          label="Guardar cambios"
                          icon="pi pi-check"
                          className="pf-btn-edit"
                          loading={loading}
                          onClick={() => { onSubmit(); }}
                        />
                      </>
                    ) : (
                      <>
                        <Button
                          type="button"
                          label="Cambiar contraseña"
                          icon="pi pi-lock"
                          className="pf-btn-cancel"
                          onClick={() => setShowPasswordModal(true)}
                        />
                        <Button
                          type="button"
                          label="Editar perfil"
                          icon="pi pi-pencil"
                          className="pf-btn-edit"
                          loading={loading}
                          onClick={() => setEditShape(false)}
                        />
                      </>
                    )}
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Change password modal */}
        <Dialog
          header="Cambiar contraseña"
          visible={showPasswordModal}
          onHide={closePasswordModal}
          className="pf-dialog"
          style={{ width: "100%", maxWidth: "480px" }}
          draggable={false}
          resizable={false}
          modal
          footer={
            <div className="pf-actions">
              <Button
                type="button"
                label="Cancelar"
                className="pf-btn-cancel"
                onClick={closePasswordModal}
              />
              <Button
                type="button"
                label="Cambiar contraseña"
                icon="pi pi-check"
                className="pf-btn-edit"
                loading={passwordLoading}
                disabled={!isPasswordFormValid}
                onClick={onChangePassword}
              />
            </div>
          }
        >
          <div className="pf-security-note">
            <i className="pi pi-shield" style={{ marginTop: 2 }} />
            <span>
              Por motivos de seguridad necesitamos verificar la siguiente información
              antes de cambiar tu contraseña.
            </span>
          </div>

          <div className="pf-fields">
            <div className="pf-field">
              <label className="pf-label">Cédula</label>
              <div className="pf-input-wrap">
                <i className="pf-input-icon pi pi-id-card" />
                <InputText
                  value={passwordForm.citizenshipId}
                  onChange={(e) => handlePasswordField("citizenshipId", e.target.value)}
                />
              </div>
            </div>

            <div className="pf-field">
              <label className="pf-label">Ciudad</label>
              <div className="pf-input-wrap">
                <i className="pf-input-icon pi pi-building" />
                <InputText
                  value={passwordForm.city}
                  onChange={(e) => handlePasswordField("city", e.target.value)}
                />
              </div>
            </div>

            <div className="pf-field">
              <label className="pf-label">Dirección</label>
              <div className="pf-input-wrap">
                <i className="pf-input-icon pi pi-map-marker" />
                <InputText
                  value={passwordForm.address}
                  onChange={(e) => handlePasswordField("address", e.target.value)}
                />
              </div>
            </div>

            <div className="pf-field">
              <label className="pf-label">Nueva contraseña</label>
              <div className="pf-input-wrap">
                <i className="pf-input-icon pi pi-lock" />
                <InputText
                  type="password"
                  autoComplete="new-password"
                  value={passwordForm.newPassword}
                  onChange={(e) => handlePasswordField("newPassword", e.target.value)}
                />
              </div>
            </div>

            <div className="pf-field">
              <label className="pf-label">Confirmar contraseña</label>
              <div className="pf-input-wrap">
                <i className="pf-input-icon pi pi-lock" />
                <InputText
                  type="password"
                  autoComplete="new-password"
                  value={passwordForm.confirmPassword}
                  onChange={(e) => handlePasswordField("confirmPassword", e.target.value)}
                />
              </div>
              {passwordForm.confirmPassword !== "" && !passwordsMatch && (
                <span className="pf-error-text">Las contraseñas no coinciden</span>
              )}
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
}
 
export default Profile;